export default {
  /**
   * Props a notification based on given params
   * @param {Object} self Vm rev
   * @param {String} message
   * @param {String} status
   * @param {String} icon
   * @param {Boolean} canTimeout
   * @param {Number} ttl
   * @param {String} notificationType
   */
  propNotification (self, message = '', status = 'ok', icon = 'trial', canTimeout = true, ttl = this.defaultTtl(), notificationType = 'normal', buttons = []) {
    let notification = {
      message,
      status,
      icon,
      type: notificationType,
      canTimeout,
      lastFor: ttl,
      buttons
    }

    let notificationObject = {
      type: notificationType,
      notification
    }
    self.$store.commit('addNotification', notificationObject)
  },

  /**
   * Adds a ok notification
   * @param {Object} self Vm ref
   * @param {String} msg
   * @param {Boolean} canTimeout
   */
  okNotification (self, msg = '', canTimeout = true, ttl = this.defaultTtl()) {
    this.propNotification(self, msg, 'ok', 'connected', canTimeout, ttl)
  },

  /**
   * Adds a nok notification
   * @param {Object} self Vm ref
   * @param {String} msg
   * @param {Boolean} canTimeout
   */
  nokNotification (self, msg = '', canTimeout = true) {
    this.propNotification(self, msg, 'nok', 'trial', canTimeout)
  },

  /**
   * Adds an informative notification
   * @param {Object} self Vm ref
   * @param {String} msg
   * @param {Boolean} canTimeout
   */
  infoNotification (self, msg = '', canTimeout = true) {
    this.propNotification(self, msg, 'info', 'embarrassing', canTimeout)
  },

  /**
   * Adds an informative notification
   * @param {Object} self Vm ref
   * @param {String} msg
   * @param {Boolean} canTimeout
   */
  actionNotification (self, msg = '', actions = []) {
    this.propNotification(self, msg, 'info', 'embarrassing', false, this.defaultTtl(), 'normal', actions)
  },

  /**
   * Adds an error report notification
   * @param {Object} self Vm ref
   * @param {String} msg
   */
  reportNotification (self, msg = '') {
    this.propNotification(self, msg, 'report', 'embarrassing', false)
  },

  /**
   * Adds an event notification
   * @param {Object} self Vm ref
   * @param {String} msg
   * @param {Boolean} canTimeout
   */
  eventNotification (self, msg = '', canTimeout = true) {
    this.propNotification(self, msg, 'info', 'embarrassing', canTimeout, this.defaultTtl(), 'event')
  },

  /**
   * Removes normal notification
   * @param {Object} self Vm ref
   */
  removeNotification (self) {
    self.$store.commit('removeNotification', 'normal')
  },

  /**
   * Gives notification's default TTL
   * @returns {Number}
   */
  defaultTtl () {
    return 3000
  }
}

const preProcess = {
  /**
   * Creates a string of issues, that occured during
   * the update
   * @returns {String}}
   */
  makeIssueString (issues = {}) {
    let seenIssues = {}
    let rtr = '<ul class="report-list">'
    for (let c in issues) {
      rtr += `<li>${c}: `
      for (let i of issues[c]) {
        if (i && !seenIssues[i]) {
          rtr += `${i}, `
          // seenIssues[i] = true
        }
      }
      rtr = rtr.trim().slice(0, -1) + '</li>'
    }
    return `${rtr}</ul>`
  }
}

export { preProcess as preProcess }



// WEBPACK FOOTER //
// ./src/assets/modules/notifications/manager.js